import IJsonTool from '@/module/common/service/UtilsService/contract/IJsonTool';
import IUtilsService from '@/module/common/service/UtilsService/contract/IUtilsService';
import JsonToolException from '@/module/common/service/UtilsService/exception/JsonToolException';

class JsonTool implements IJsonTool {
  private utilsService: IUtilsService;

  constructor(utilsService: IUtilsService) {
    this.utilsService = utilsService;
  }

  from = <T>(json: string): T => {
    if (!this.utilsService.typeCheck.isString(json)) {
      throw new JsonToolException('Wrong JSON format.');
    }

    try {
      const result = JSON.parse(json);

      if (!this.utilsService.typeCheck.isArray(result) && !this.utilsService.typeCheck.isObject(result)) {
        throw new JsonToolException('Wrong JSON format.');
      }

      return result as unknown as T;
    } catch (e) {
      throw new JsonToolException('Wrong JSON format.');
    }
  };

  to = <T>(data: T): string => {
    const isArray = this.utilsService.typeCheck.isArray(data);
    const isObject = this.utilsService.typeCheck.isObject(data);

    if (!isArray && !isObject) {
      throw new JsonToolException('Only objects & arrays allowed.');
    }

    if (isArray) {
      return JSON.stringify(this.castUndefinedToNullInArrayRecursive(data));
    }

    return JSON.stringify(this.castUndefinedToNullInObjectRecursive(data));
  };

  private castUndefinedToNullInArrayRecursive = (array: unknown[]) => array
    .reduce((result: unknown[], value) => {
      if (this.utilsService.typeCheck.isUndefined(value)) {
        result.push(null);
      } else if (this.utilsService.typeCheck.isArray(value)) {
        result.push(this.castUndefinedToNullInArrayRecursive(value));
      } else if (this.utilsService.typeCheck.isObject(value)) {
        result.push(this.castUndefinedToNullInObjectRecursive(value));
      } else {
        result.push(value);
      }

      return result;
    }, []);

  private castUndefinedToNullInObjectRecursive = (obj: object) => Object.keys(obj)
    .reduce((result: object, key) => {
      if (this.utilsService.typeCheck.isUndefined(obj[key])) {
        result[key] = null;
      } else if (this.utilsService.typeCheck.isArray(obj[key])) {
        result[key] = this.castUndefinedToNullInArrayRecursive(obj[key]);
      } else if (this.utilsService.typeCheck.isObject(obj[key])) {
        result[key] = this.castUndefinedToNullInObjectRecursive(obj[key]);
      } else {
        result[key] = obj[key];
      }

      return result;
    }, {});
}

export default JsonTool;
